import pAudit from './publicAudit.js'
import examineTemplate from '../examineTemplate'

export default {
  props: {
    property: Object,
    isShow: Boolean,
    view: Boolean
  },
  components: {
    examineTemplate
  },
  data() {
    return {
      show: false,
      /* 表格數據 */
      title: '',
      gys: '',
      zh: '',
      lrrname: '',
      je: '',
      jexx: '',
      jedx: '',
      yt: '',
      spbz: '',
      bz: '',
      khh: '',
      flowId: '',
      isAgree: '',
      djh: '',
      shyj: '',
      shr: '',
      tgje: '',
      rq: '',
      documentType: '',
      ywbm: '',
      tableData: [],
      workflowData: [],
      sh: {}
    }
  },
  created() {
    pAudit.setThis(this)
    this.initData(this.property)
    this.show = true
  },
  methods: {
    initData(fksqd) {

      const data = this.$data
      Object.keys(data).forEach(key => {
        if (typeof data[key] === 'string' && data[key] !== undefined && fksqd[key] !== null && fksqd[key] !== '') {
          data[key] = fksqd[key]
        }
      })
      this.jexx = pAudit.formatAmount(this.je)
      this.jedx = pAudit.convertCurrency(this.je)
      const constact = {
        maindjh: data.djh,
        billValue: data.documentType
      }
      this.title = pAudit.getPurchaseCgNameByCode(data)
      this.$post('/fesback/purchase/getContracts.z', constact).then(response => {
        this.workflowData = []
        this.tableData = response.data.contracts
        const shNames = {
          'fksqd1': '会计审核',
          'fksqd3': '副总经理',
          'fksqd4': '财务部长',
          'fksqd5': '总经理',
          'fksqd6': '总会计师',
          'fksqd7': '董事长',
          'fksqd8': '集团CFO',
          'fksqd9': '集团供应链'
        }
        if (fksqd.shr) {
          this.workflowData.unshift({
            shsj: fksqd.shrq.split('.')[0],
            lcName: '部门负责人',
            shr: fksqd.shr,
            auditStatus: '批准',
            shje: pAudit.formatAmount(fksqd.tgje),
            shyj: '提交'
          })
        }
        response.data.sh.forEach(item => {
          const nodeName = item.lcName
          if (nodeName === '集团CFO审批') {
            item.lcid = 'fksqd8'
          } else if (nodeName === '董事长审批') {
            item.lcid = 'fksqd7'
          } else if (nodeName === '总会计师审批') {
            item.lcid = 'fksqd6'
          } else if (nodeName === '总经理审批') {
            item.lcid = 'fksqd5'
          } else if (nodeName === '财务部长审批') {
            item.lcid = 'fksqd4'
          } else if (nodeName === '主管副总审批') {
            item.lcid = 'fksqd3'
          } else if (nodeName === '财务主管会计审批') {
            item.lcid = 'fksqd1'
          } else if (nodeName === '集团供应链审批' || nodeName === '集团供应链审批2') {
            item.lcid = 'fksqd9'
          }
          this.sh[item.lcid] = item.shr
          if (item.shr) {
            this.workflowData.unshift({
              shsj: item.shsj.split('.')[0],
              lcName: shNames[item.lcid],
              shr: item.shr,
              auditStatus: item.shbz === '1' ? '批准' : '退回',
              shje: pAudit.formatAmount(Number(item.shje, 2)),
              shyj: item.shyj
            })
          }
        })
        if (fksqd.recipient) {
          this.workflowData.unshift({
            shr: fksqd.recipient,
            auditStatus: '未办理'
          })
        }
      })
    },
    htView(index, row) {
      this.$post('/fesback/purchase/getContractDocumentAddress.z', { hth: row.hth }).then(res => {
        window.open(res.data, '_blank')
      })
    },
    fksqdClose() {
      this.show = false
      this.$emit('fksqdClose')
    },
    agreeClick() {
      pAudit.agreeClick()
    },
    refuseClick() {
      pAudit.refuseClick()
    },
    findPage() {
      this.$emit('findPage')
    }


  }
}
